import { LockClosedIcon } from "@heroicons/react/24/solid";

/**
 * Map layer row — opens upgrade modal when locked, otherwise toggles layer.
 */
export default function LayerToggleRow({
  icon,
  label,
  locked,
  checked,
  onToggle,
  onLockedClick,
  featureName,
}) {
  const displayName = featureName || label;

  if (locked) {
    return (
      <button
        type="button"
        onClick={() => onLockedClick(displayName)}
        className="flex w-full items-center justify-between rounded-lg border border-borderGray bg-white/[0.03] p-2 text-left opacity-80 transition hover:bg-white/[0.06] hover:opacity-100"
      >
        <div className="flex items-center space-x-2">
          <span className="text-sm">{icon}</span>
          <span className="text-sm text-white">{label}</span>
        </div>
        <LockClosedIcon className="h-5 w-5 text-amber-300/90" aria-hidden />
      </button>
    );
  }

  return (
    <div className="flex items-center justify-between rounded-lg border border-borderGray p-2">
      <div className="flex items-center space-x-2">
        <span className="text-sm">{icon}</span>
        <span className="text-sm text-white">{label}</span>
      </div>
      <label className="relative inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={onToggle}
          className="peer sr-only"
        />
        <div className="peer h-6 w-11 rounded-full bg-gray-600 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:transition-all peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300" />
      </label>
    </div>
  );
}
